import { useSelector } from "react-redux";
import { MONTH_CONSTANT } from "constants/MonthConstants";
import { useIntl } from "react-intl";
import { QUARTER_YEAR_CONST } from "constants/PublicationConstants";
import getYearName from "./getYearName";

/**
 * @param {number} periodicId - The periodicId
 * @param {string} studyPeriodAsString - The study period to be converted to the right format according to the language
 * @returns The right stud period according to the specified language
 */

export function GetStudyPeriod(yearTypeId, periodicId, studyPeriodAsString) {
  const intl = useIntl();

  if (studyPeriodAsString !== null && studyPeriodAsString !== "") {
    var studyPeriodSplittedArr = studyPeriodAsString.split(" - ");
    switch (periodicId) {
      case 1:
      case 2:
        var month = parseInt(studyPeriodSplittedArr[0]);
        return (
          intl.formatMessage({ id: MONTH_CONSTANT[month - 1].labelId }) +
          " - " +
          getYearName(yearTypeId, parseInt(studyPeriodSplittedArr[1]))
        );
      case 3:
        var quarter = parseInt(studyPeriodSplittedArr[0]);
        return (
          intl.formatMessage({ id: QUARTER_YEAR_CONST[quarter - 1].labelId }) +
          " - " +
          getYearName(yearTypeId, parseInt(studyPeriodSplittedArr[1]))
        );
      default:
        return getYearName(yearTypeId, parseInt(studyPeriodSplittedArr));
    }
  }
  return "N/A";
}
